import { ComponentProps, forwardRef } from "react";

import { cn } from "@/lib/utils";

import { type CreatedLinkComponent, Link } from "../link";
import { isExternalLink } from "./sidebar-menu-nav-item.utils";

type SidebarLinkProps = Omit<ComponentProps<typeof CreatedLinkComponent>, "ref"> & { active?: boolean };

export const SidebarLink = forwardRef<HTMLAnchorElement, SidebarLinkProps>(
    ({ to, children, className, asChild, active, ...props }, ref) => {
        const isExternal = isExternalLink(to);

        const activeClass = active && "font-medium [&>svg]:text-sidebar-accent-foreground!";
        className = cn(
            "[&>svg]:text-sidebar-foreground! hover:[&>svg]:text-sidebar-accent-foreground! active:hover:[&>svg]:text-sidebar-accent-foreground! active:[&>svg]:text-sidebar-accent-foreground!",
            activeClass,
            className
        );

        if (isExternal) {
            return (
                <Link ref={ref} href={to} className={className} asChild={asChild} external {...props}>
                    {children}
                </Link>
            );
        }

        return (
            <Link ref={ref} to={to} className={className} asChild={asChild} {...props}>
                {children}
            </Link>
        );
    }
);

SidebarLink.displayName = "SidebarLink";
